// extracted by mini-css-extract-plugin
module.exports = {"tagsContent":"TagsContent_tagsContent__22KJi","title":"TagsContent_title__1_Tod","tagNameField":"TagsContent_tagNameField__3oECL","tagList":"TagsContent_tagList__2npmj"};